import request from '../request'

// 获取信息列表
export function getInfoList(params = {}){
    return request({
        method:'GET',
        url:'/verify/information/list',
        params
    })
}

// 添加信息
export function addInfoOne(data = {}){
    return request({
        method:'POST',
        url:'/verify/information/one',
        data,
        type:'img'
    })
}
// 修改信息
export function setInfoOne(data = {}){
    return request({
        method:'post',
        url:'/verify/information/onepost',
        data,
        type:'img'
    })
}
// 删除信息
export function delInfoOne(params = {}){
    return request({
        method:'DELETE',
        url:'/verify/information/one',
        params
    })
}


// 修改视频tag
export function updatetag(params = {}){
    return request({
        method:'POST',
        url:'/verify/information/updatetag',
        params
    })
}
// 获取地名遗产
export function getVillageList(params = {}){
    return request({
        method:'GET',
        url:'/page/information/list',
        params
    })
}

// 获取小程序码
export function addCode(data){
    return request({
        method:'POST',
        url:'/getewm',
        data,
    })
}